import type { User } from "@entities/user";
import { Role } from "@/shared/types";

const DEMO_TENANT_ID = "1";

export const mockUsers: User[] = [
  {
    id: "user-admin-1",
    tenant_id: DEMO_TENANT_ID,
    email: "admin@demo.com",
    firstName: "Maria",
    lastName: "Schneider",
    role: Role.AccountAdmin,
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "user-manager-1",
    tenant_id: DEMO_TENANT_ID,
    email: "manager@demo.com",
    firstName: "Technical",
    lastName: "Manager",
    role: Role.TechnicalManager,
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "demo-user-1",
    tenant_id: DEMO_TENANT_ID,
    email: "s.hartmann@baeckerei-rhein-neckar.de",
    firstName: "Sabine",
    lastName: "Hartmann",
    role: Role.AccountAdmin,
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "demo-user-2",
    tenant_id: DEMO_TENANT_ID,
    email: "k.brenner@baeckerei-rhein-neckar.de",
    firstName: "Klaus",
    lastName: "Brenner",
    role: Role.TechnicalManager,
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "demo-user-3",
    tenant_id: DEMO_TENANT_ID,
    email: "t.mueller@baeckerei-rhein-neckar.de",
    firstName: "Thomas",
    lastName: "Müller",
    role: Role.TechnicalUser,
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "demo-user-4",
    tenant_id: DEMO_TENANT_ID,
    email: "s.weber@baeckerei-rhein-neckar.de",
    firstName: "Stefan",
    lastName: "Weber",
    role: Role.TechnicalUser,
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "demo-user-5",
    tenant_id: DEMO_TENANT_ID,
    email: "l.hoffmann@baeckerei-rhein-neckar.de",
    firstName: "Lisa",
    lastName: "Hoffmann",
    role: Role.User,
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];
